"use client";

import AnimatedCircularShapes from "./animated-circular-shapes";
import RotatingText from "./rotating-text";

export function CombinedMakeItBetterCircle() {
  return (
    <div className="w-full h-full bg-[#FAFAFA] dark:bg-black backdrop-blur-lg relative lg:border-r-2 md:border-r md:border-l border-[#EAEAEA] dark:border-[#1E1E1E] z-[50]">
      {/* Make It Better button - positioned absolutely in the center top */}
      <div className="absolute -top-10 h-[100px] md:border-t-2 md:border-l-2 lg:border-2 md:border-r border-b-2 border-t-2 border-l-2 border-r-2 border-[#EAEAEA] dark:border-[#1E1E1E] -left-[1px] -right-[1px] flex bg-[#FAFAFA] dark:bg-black items-center justify-center z-[50] gap-2">
        <h3 className="text-md sm:text-lg lg:text-2xl mb-1 font-semibold z-[70]">Make it</h3>
        <RotatingText
          texts={["Better", "Special", "Fancy", "Greater", "Perfect", "Superb"]}
          mainClassName="text-md sm:text-lg lg:text-2xl px-2 sm:px-2 md:px-3 bg-[#E6E6E6] dark:bg-[#282828] font-medium overflow-hidden lg:py-0.5 rounded-lg"
          staggerFrom={"first"}
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "-120%" }}
          staggerDuration={0.025}
          splitLevelClassName="overflow-hidden pb-0.5 sm:pb-1 md:pb-1"
          transition={{ type: "spring", damping: 30, stiffness: 400 }}
          rotationInterval={2500}
        />
      </div>

      {/* Animated Circle - takes full height and width */}
      <div className="w-full h-full pt-15 z-[50] overflow-hidden">
        <AnimatedCircularShapes />
      </div>
    </div>
  );
}
